import React, { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as matchActions from '~/store/modules/matches/actions';
import { Mobile, Desktop } from './responsive';
import { Responsive } from '~/components';

const Match = () => {
  const dispatch = useDispatch();
  const {
    selectedMatch: { data: selectedMatch, failed },
  } = useSelector(state => state.matches);
  const {
    data: { matchIsBeingPlayed },
  } = useSelector(state => state.matches.matchStatus);

  const {
    params: { id },
  } = useRouteMatch();

  useEffect(() => {
    if (selectedMatch) {
      dispatch(
        matchActions.getSelectedMatchPublicFilesRequest(selectedMatch.id)
      );
    }
  }, [dispatch, selectedMatch]);

  useEffect(() => {
    if (selectedMatch && selectedMatch.homeTeam && selectedMatch.awayTeam) {
      dispatch(
        matchActions.getSquadsRequest(
          selectedMatch.homeTeam.id,
          selectedMatch.awayTeam.id
        )
      );
    }
  }, [dispatch, selectedMatch]);

  useEffect(() => {
    dispatch(matchActions.getSelectedMatchRequest(id));
  }, [id, dispatch]);

  useEffect(() => {
    const fetchEvents = () => {
      if (selectedMatch) {
        dispatch(matchActions.getSelectedMatchStatusRequest(selectedMatch.id));
      }
    };

    fetchEvents();
    const interval = setInterval(fetchEvents, 60000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch, selectedMatch, matchIsBeingPlayed]);

  return (
    <Responsive
      sm={<Mobile failed={failed} />}
      lg={<Desktop failed={failed} />}
    />
  );
};

Match.propTypes = {};

export default Match;
